import { useAuth } from 'context/auth';
import usePatchUserPreferences from 'hooks/services/user/usePatchUserPreferences';
import { useMemo } from 'react';

export const useDeleteInCrmPreference = () => {
  const { user } = useAuth();
  const { mutate: patchUserPreferences } = usePatchUserPreferences();

  const deleteInCrmPreference = user?.userPreferences?.deleteInCrm ?? true;

  return useMemo(
    () => ({
      deleteInCrmPreference,
      saveDeleteInCrmPreference: (value: boolean) => {
        if (value === deleteInCrmPreference) {
          return;
        }

        patchUserPreferences({ deleteInCrm: value });

        if (user?.userPreferences) {
          user.userPreferences.deleteInCrm = value;
        }
      },
    }),
    [user, deleteInCrmPreference, patchUserPreferences],
  );
};
